// PublicRoute.tsx
import { Navigate } from "react-router-dom";

const PublicRoute = ({ element }: { element: React.ReactNode }) => {
  const isAuth = localStorage.getItem("access_token");

  if (isAuth) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{element}</>;
};

export default PublicRoute;